import React from 'react'
import PropTypes from 'prop-types'
import BodyClassName from 'react-body-classname'

import 'assets/css/index.sass'
import 'assets/css/pages/login.css'

const Layout = props => (
  <BodyClassName className="login">
    {props.children}
  </BodyClassName>
)

Layout.propTypes = {
  children: PropTypes.element.isRequired,
}

export default Layout
